// Hook do pobierania słownika grup klientów – GET /panel/clients/clients-groups/dictionary

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IClientsGroupsDictionaryItem {
  text: string;
  value: number;
}

export interface IGetPanelClientsGroupsDictionaryResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: IClientsGroupsDictionaryItem[];
}

const getPanelClientsGroupsDictionary =
  (): Promise<IGetPanelClientsGroupsDictionaryResponse> =>
    axios.get('/panel/clients/clients-groups/dictionary');

export const useGetPanelClientsGroupsDictionary = (
  options?: UseQueryOptions<IGetPanelClientsGroupsDictionaryResponse, IError>
) =>
  useQuery<IGetPanelClientsGroupsDictionaryResponse, IError>(
    ['panel', 'clients', 'clients-groups', 'dictionary'],
    () => getPanelClientsGroupsDictionary(),
    options
  );
